<ng-template #choiceTemplate let-data="data">
  <div class="p-space-sm" style="width: 400px">
    <cam-menu-navigation
      [menu]="this.menu"
      container="tags"
      [options]="{
        spaceElement: 'xs',
      }"
    ></cam-menu-navigation>
  </div>
  <div class="g-space-sm">
    @for (option of this.filteredItems(data.items); track option.id) {
      <div
        class="flex-row pointer m-space-sm p-space-sm item"
        [class.is-selected]="data.isselected(option)"
        (click)="data.select(option)"
      >
        {{ option.name }}
      </div>
    }
  </div>
</ng-template>
